module.exports = __webpack_public_path__ + "i18n/ko_dffd90e9e2bd67177207b41a3ba9eabf.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 153